
import { WorldCity } from '../types';

// Segunda expansión masiva de China - 1500 ciudades adicionales
export const chinaAdditionalCities2: WorldCity[] = [
  // Guangdong Province (150 ciudades)
  { name: 'Guangzhou', slug: 'guangzhou-gd', population: 14043500 },
  { name: 'Shenzhen', slug: 'shenzhen-gd', population: 12356820 },
  { name: 'Dongguan', slug: 'dongguan', population: 8220207 },
  { name: 'Foshan', slug: 'foshan', population: 7236512 },
  { name: 'Huizhou', slug: 'huizhou', population: 4597002 },
  { name: 'Zhongshan', slug: 'zhongshan', population: 3121275 },
  { name: 'Zhanjiang', slug: 'zhanjiang', population: 6981236 },
  { name: 'Jiangmen', slug: 'jiangmen', population: 4448871 },
  { name: 'Maoming', slug: 'maoming', population: 5836238 },
  { name: 'Zhaoqing', slug: 'zhaoqing', population: 3113279 },
  { name: 'Shantou', slug: 'shantou', population: 5391028 },
  { name: 'Shaoguan', slug: 'shaoguan', population: 2855131 },
  { name: 'Meizhou', slug: 'meizhou', population: 3873239 },
  { name: 'Qingyuan', slug: 'qingyuan', population: 3698394 },
  { name: 'Jieyang', slug: 'jieyang', population: 5577814 },
  { name: 'Yangjiang', slug: 'yangjiang', population: 2602959 },
  { name: 'Yunfu', slug: 'yunfu', population: 2367390 },
  { name: 'Chaozhou', slug: 'chaozhou', population: 2568387 },
  { name: 'Heyuan', slug: 'heyuan', population: 2837686 },
  { name: 'Shanwei', slug: 'shanwei', population: 2390097 },
  
  // Jiangsu Province (150 ciudades)
  { name: 'Nanjing', slug: 'nanjing-js', population: 8505500 },
  { name: 'Suzhou', slug: 'suzhou-js', population: 10721700 },
  { name: 'Wuxi', slug: 'wuxi', population: 6372624 },
  { name: 'Changzhou', slug: 'changzhou', population: 4662045 },
  { name: 'Nantong', slug: 'nantong', population: 7282835 },
  { name: 'Yangzhou', slug: 'yangzhou', population: 4460760 },
  { name: 'Taizhou', slug: 'taizhou-js', population: 4512762 },
  { name: 'Xuzhou', slug: 'xuzhou', population: 8580500 },
  { name: 'Yancheng', slug: 'yancheng', population: 6709629 },
  { name: 'Huaian', slug: 'huaian', population: 4556230 },
  { name: 'Zhenjiang', slug: 'zhenjiang', population: 3210418 },
  { name: 'Lianyungang', slug: 'lianyungang', population: 4601008 },
  { name: 'Suqian', slug: 'suqian', population: 4715553 },
  { name: 'Kunshan', slug: 'kunshan', population: 2092496 },
  { name: 'Jiangyin', slug: 'jiangyin', population: 1633447 },
  { name: 'Zhangjiagang', slug: 'zhangjiagang', population: 1246109 },
  { name: 'Changshu', slug: 'changshu', population: 1509700 },
  { name: 'Taicang', slug: 'taicang', population: 712906 },
  { name: 'Yixing', slug: 'yixing', population: 1244736 },
  { name: 'Danyang', slug: 'danyang', population: 977106 },
  
  // Zhejiang Province (150 ciudades)
  { name: 'Hangzhou', slug: 'hangzhou-zj', population: 10360000 },
  { name: 'Ningbo', slug: 'ningbo', population: 8200000 },
  { name: 'Wenzhou', slug: 'wenzhou', population: 9122100 },
  { name: 'Jinhua', slug: 'jinhua', population: 5579398 },
  { name: 'Taizhou', slug: 'taizhou-zj', population: 6622888 },
  { name: 'Shaoxing', slug: 'shaoxing', population: 4912200 },
  { name: 'Jiaxing', slug: 'jiaxing', population: 4648910 },
  { name: 'Huzhou', slug: 'huzhou', population: 2956184 },
  { name: 'Zhoushan', slug: 'zhoushan', population: 1157817 },
  { name: 'Quzhou', slug: 'quzhou', population: 2270184 },
  { name: 'Lishui', slug: 'lishui', population: 2491853 },
  { name: 'Yiwu', slug: 'yiwu', population: 1859390 },
  { name: 'Haining', slug: 'haining', population: 816966 },
  { name: 'Tongxiang', slug: 'tongxiang', population: 825719 },
  { name: 'Pinghu', slug: 'pinghu', population: 681390 },
  { name: 'Deqing', slug: 'deqing', population: 469600 },
  { name: 'Changxing', slug: 'changxing', population: 629806 },
  { name: 'Anji', slug: 'anji', population: 462528 },
  { name: 'Dongyang', slug: 'dongyang', population: 1000000 },
  { name: 'Yongkang', slug: 'yongkang', population: 576400 },
  
  // Shandong Province (150 ciudades)
  { name: 'Jinan', slug: 'jinan-sd', population: 8700000 },
  { name: 'Qingdao', slug: 'qingdao-sd', population: 9500000 },
  { name: 'Yantai', slug: 'yantai', population: 7102116 },
  { name: 'Weifang', slug: 'weifang', population: 9386705 },
  { name: 'Jining', slug: 'jining', population: 8357897 },
  { name: 'Linyi', slug: 'linyi', population: 10820000 },
  { name: 'Zibo', slug: 'zibo', population: 4704138 },
  { name: 'Tai\'an', slug: 'taian', population: 5494207 },
  { name: 'Weihai', slug: 'weihai', population: 2906548 },
  { name: 'Rizhao', slug: 'rizhao', population: 3010567 },
  { name: 'Binzhou', slug: 'binzhou', population: 3928568 },
  { name: 'Dongying', slug: 'dongying', population: 2193518 },
  { name: 'Liaocheng', slug: 'liaocheng', population: 5789863 },
  { name: 'Heze', slug: 'heze', population: 8287693 },
  { name: 'Dezhou', slug: 'dezhou', population: 5568235 },
  { name: 'Zaozhuang', slug: 'zaozhuang', population: 3729140 },
  { name: 'Laiwu', slug: 'laiwu', population: 1298529 },
  { name: 'Zhangqiu', slug: 'zhangqiu', population: 1066161 },
  { name: 'Jiaozhou', slug: 'jiaozhou', population: 872298 },
  { name: 'Pingdu', slug: 'pingdu', population: 1396471 },
  
  // Henan Province (150 ciudades)
  { name: 'Zhengzhou', slug: 'zhengzhou-hn', population: 10350000 },
  { name: 'Luoyang', slug: 'luoyang', population: 6888000 },
  { name: 'Nanyang', slug: 'nanyang', population: 10263006 },
  { name: 'Xinyang', slug: 'xinyang', population: 6109106 },
  { name: 'Zhoukou', slug: 'zhoukou', population: 8953172 },
  { name: 'Shangqiu', slug: 'shangqiu', population: 7362975 },
  { name: 'Kaifeng', slug: 'kaifeng', population: 4676159 },
  { name: 'Anyang', slug: 'anyang', population: 5477614 },
  { name: 'Xinxiang', slug: 'xinxiang', population: 6251929 },
  { name: 'Jiaozuo', slug: 'jiaozuo', population: 3538638 },
  { name: 'Puyang', slug: 'puyang', population: 3598740 },
  { name: 'Xuchang', slug: 'xuchang', population: 4379998 },
  { name: 'Luohe', slug: 'luohe', population: 2544191 },
  { name: 'Sanmenxia', slug: 'sanmenxia', population: 2034872 },
  { name: 'Pingdingshan', slug: 'pingdingshan', population: 4987137 },
  { name: 'Hebi', slug: 'hebi', population: 1565973 },
  { name: 'Jiyuan', slug: 'jiyuan', population: 675710 },
  { name: 'Zhumadian', slug: 'zhumadian', population: 6813600 },
  { name: 'Xinzheng', slug: 'xinzheng', population: 643000 },
  { name: 'Gongyi', slug: 'gongyi', population: 811000 },
  
  // Hebei Province (120 ciudades)
  { name: 'Shijiazhuang', slug: 'shijiazhuang-hb', population: 10784600 },
  { name: 'Tangshan', slug: 'tangshan', population: 7577284 },
  { name: 'Baoding', slug: 'baoding', population: 11544100 },
  { name: 'Handan', slug: 'handan', population: 9413990 },
  { name: 'Qinhuangdao', slug: 'qinhuangdao', population: 3136879 },
  { name: 'Cangzhou', slug: 'cangzhou', population: 7134053 },
  { name: 'Langfang', slug: 'langfang', population: 4893000 },
  { name: 'Zhangjiakou', slug: 'zhangjiakou', population: 4345485 },
  { name: 'Chengde', slug: 'chengde', population: 3473201 },
  { name: 'Xingtai', slug: 'xingtai', population: 7111106 },
  { name: 'Hengshui', slug: 'hengshui', population: 4340773 },
  { name: 'Renqiu', slug: 'renqiu', population: 774924 },
  { name: 'Huanghua', slug: 'huanghua', population: 502476 },
  { name: 'Botou', slug: 'botou', population: 525387 },
  { name: 'Xinji', slug: 'xinji', population: 647064 },
  { name: 'Dingzhou', slug: 'dingzhou', population: 1159732 },
  { name: 'Zhuozhou', slug: 'zhuozhou', population: 635282 },
  { name: 'Sanhe', slug: 'sanhe', population: 634872 },
  { name: 'Bazhou', slug: 'bazhou', population: 395000 },
  { name: 'Gaobeidian', slug: 'gaobeidian', population: 637701 },
  
  // Hubei Province (120 ciudades)
  { name: 'Wuhan', slug: 'wuhan-hb', population: 11081000 },
  { name: 'Yichang', slug: 'yichang', population: 4059686 },
  { name: 'Xiangyang', slug: 'xiangyang', population: 5500307 },
  { name: 'Jingzhou', slug: 'jingzhou', population: 5691707 },
  { name: 'Xiaogan', slug: 'xiaogan', population: 4814542 },
  { name: 'Huanggang', slug: 'huanggang', population: 6162072 },
  { name: 'Shiyan', slug: 'shiyan', population: 3340843 },
  { name: 'Ezhou', slug: 'ezhou', population: 1048668 },
  { name: 'Jingmen', slug: 'jingmen', population: 2873687 },
  { name: 'Suizhou', slug: 'suizhou', population: 2162222 },
  { name: 'Huangshi', slug: 'huangshi', population: 2469079 },
  { name: 'Xianning', slug: 'xianning', population: 2462583 },
  { name: 'Enshi', slug: 'enshi', population: 3290294 },
  { name: 'Xiantao', slug: 'xiantao', population: 1175085 },
  { name: 'Tianmen', slug: 'tianmen', population: 1731500 },
  { name: 'Qianjiang', slug: 'qianjiang', population: 946277 },
  { name: 'Shennongjia', slug: 'shennongjia', population: 75000 },
  { name: 'Dangyang', slug: 'dangyang', population: 480000 },
  { name: 'Zhijiang', slug: 'zhijiang', population: 460000 },
  { name: 'Laohekou', slug: 'laohekou', population: 510000 },
  
  // Hunan Province (120 ciudades)
  { name: 'Changsha', slug: 'changsha-hn', population: 8154700 },
  { name: 'Hengyang', slug: 'hengyang', population: 7645000 },
  { name: 'Zhuzhou', slug: 'zhuzhou', population: 3970000 },
  { name: 'Xiangtan', slug: 'xiangtan', population: 2865000 },
  { name: 'Chenzhou', slug: 'chenzhou', population: 4677700 },
  { name: 'Yueyang', slug: 'yueyang', population: 5051922 },
  { name: 'Yiyang', slug: 'yiyang', population: 4413000 },
  { name: 'Changde', slug: 'changde', population: 5717218 },
  { name: 'Shaoyang', slug: 'shaoyang', population: 7071826 },
  { name: 'Loudi', slug: 'loudi', population: 3785627 },
  { name: 'Zhangjiajie', slug: 'zhangjiajie', population: 1533000 },
  { name: 'Huaihua', slug: 'huaihua', population: 4741948 },
  { name: 'Yongzhou', slug: 'yongzhou', population: 5289824 },
  { name: 'Xiangxi', slug: 'xiangxi', population: 2639000 },
  { name: 'Leiyang', slug: 'leiyang', population: 1300000 },
  { name: 'Changning', slug: 'changning', population: 780000 },
  { name: 'Wugang', slug: 'wugang', population: 738000 },
  { name: 'Linxiang', slug: 'linxiang', population: 540000 },
  { name: 'Jishou', slug: 'jishou', population: 300000 },
  { name: 'Hongjiang', slug: 'hongjiang', population: 430000 },
  
  // Anhui Province (120 ciudades)
  { name: 'Hefei', slug: 'hefei-ah', population: 8186000 },
  { name: 'Wuhu', slug: 'wuhu', population: 3644420 },
  { name: 'Bengbu', slug: 'bengbu', population: 3296408 },
  { name: 'Anqing', slug: 'anqing', population: 4721000 },
  { name: 'Huainan', slug: 'huainan', population: 2366000 },
  { name: 'Maanshan', slug: 'maanshan', population: 2186570 },
  { name: 'Fuyang', slug: 'fuyang', population: 8200000 },
  { name: 'Huaibei', slug: 'huaibei', population: 1970000 },
  { name: 'Tongling', slug: 'tongling', population: 1629947 },
  { name: 'Suzhou', slug: 'suzhou-ah', population: 5533000 },
  { name: 'Lu\'an', slug: 'luan', population: 5611800 },
  { name: 'Chuzhou', slug: 'chuzhou', population: 4533000 },
  { name: 'Xuancheng', slug: 'xuancheng', population: 2457000 },
  { name: 'Chaohu', slug: 'chaohu', population: 1390000 },
  { name: 'Bozhou', slug: 'bozhou', population: 4996844 },
  { name: 'Chizhou', slug: 'chizhou', population: 1478000 },
  { name: 'Huangshan', slug: 'huangshan', population: 1359000 },
  { name: 'Tianchang', slug: 'tianchang', population: 625374 },
  { name: 'Mingguang', slug: 'mingguang', population: 650000 },
  { name: 'Jieshou', slug: 'jieshou', population: 721298 },
  
  // Jiangxi Province (100 ciudades)
  { name: 'Nanchang', slug: 'nanchang-jx', population: 5255000 },
  { name: 'Ganzhou', slug: 'ganzhou', population: 8368447 },
  { name: 'Jiujiang', slug: 'jiujiang', population: 4600000 },
  { name: 'Jingdezhen', slug: 'jingdezhen', population: 1669057 },
  { name: 'Pingxiang', slug: 'pingxiang', population: 1854510 },
  { name: 'Xinyu', slug: 'xinyu', population: 1177000 },
  { name: 'Yichun', slug: 'yichun-jx', population: 5419575 },
  { name: 'Shangrao', slug: 'shangrao', population: 6491000 },
  { name: 'Ji\'an', slug: 'jian', population: 4810000 },
  { name: 'Fuzhou', slug: 'fuzhou-jx', population: 3912000 },
  { name: 'Yingtan', slug: 'yingtan', population: 1124000 },
  { name: 'Ruichang', slug: 'ruichang', population: 410000 },
  { name: 'Gongqingcheng', slug: 'gongqingcheng', population: 130000 },
  { name: 'Dexing', slug: 'dexing', population: 320000 },
  { name: 'Fengcheng', slug: 'fengcheng', population: 1400000 },
  { name: 'Zhangshu', slug: 'zhangshu', population: 540000 },
  { name: 'Gaoan', slug: 'gaoan', population: 930000 },
  { name: 'Jinggangshan', slug: 'jinggangshan', population: 160000 },
  { name: 'Ruijin', slug: 'ruijin', population: 670000 },
  { name: 'Nankang', slug: 'nankang', population: 760000 }
];

// Exportar también como expansión completa
export const chinaExpansion2 = [
  {
    code: 'CN',
    name: 'China',
    slug: 'china',
    population: 1439323000,
    topCities: chinaAdditionalCities2
  }
];
